import { render, staticRenderFns } from "./templateSettings.vue?vue&type=template&id=019b8a07"
import script from "./templateSettings.vue?vue&type=script&lang=js"
export * from "./templateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports